export default __webpack_public_path__ + "static/media/articles.86fa07e5.png";